<template>
  <div id="donut-chart">
    <apexchart
      ref="donutChart"
      type="donut"
      :options="chartOptions"
      :series="chartSeries"
    ></apexchart>
  </div>
</template>

<script>
import VueApexCharts from 'vue-apexcharts'

export default {
  components: {
    apexchart: VueApexCharts,
  },
  props: {
    series: {
      type: Array,
      default: () => [],
    },
    nivel: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      chartSeries: [],
      chartOptions: {},
      _isMounted: false,
      _serieInicial: null,
    }
  },
  created() {
    this.chartOptions = {
      chart: {
        type: 'donut',
      },
      labels: ['Ótimo', 'Bom', 'Suficiente', 'Regular'],
      colors: ['#1212B6', '#38BA38', '#D5BA0A', '#C46500'],
      dataLabels: {
        formatter: function (val) {
          return parseInt(val) + '%'
        },
      },
      legend: {
        position: 'left',
      },
      tooltip: {
        y: {
          formatter: (value) => {
            let tipo = ''
            if (this.nivel == '2') {
              tipo = 'equipes'
            }
            if (this.nivel == '3') {
              tipo = 'microáreas'
            }
            return value + ` ${tipo}`
          },
        },
      },
      responsive: [
        {
          breakpoint: 480,
          options: {
            chart: {
              width: 200,
            },
            legend: {
              position: 'bottom',
            },
          },
        },
      ],
    }
  },
  mounted() {
    this._isMounted = true
    if (this._serieInicial) {
      this.atualizarGrafico(this._serieInicial)
    }
  },
  methods: {
    atualizarGrafico(seriesOrdenada) {
      const corPorClassificacao = {
        Ótimo: '#1212B6',
        Bom: '#38BA38',
        Suficiente: '#D5BA0A',
        Regular: '#C46500',
      }

      let qtd = ''
      if (this.nivel === '2') {
        qtd = 'qtd_equipes'
      } else if (this.nivel === '3') {
        qtd = 'qtd_micro_areas'
      }

      this.chartSeries = seriesOrdenada.map((el) => el[qtd])

      const novasLabels = seriesOrdenada.map((el) => el.classificacao)
      const novasCores = seriesOrdenada.map(
        (el) => corPorClassificacao[el.classificacao]
      )

      this.$nextTick(() => {
        if (this.$refs.donutChart) {
          this.$refs.donutChart.updateOptions({
            labels: novasLabels,
            colors: novasCores,
          })
        }
      })
    },
  },
  watch: {
    series: {
      handler(newValue) {
        const ordemDesejada = ['Ótimo', 'Bom', 'Suficiente', 'Regular']
        const seriesOrdenada = [...newValue].sort((a, b) => {
          return (
            ordemDesejada.indexOf(a.classificacao) -
            ordemDesejada.indexOf(b.classificacao)
          )
        })
        if (this._isMounted) {
          this.atualizarGrafico(seriesOrdenada)
        } else {
          this._serieInicial = seriesOrdenada
        }
      },
      deep: true,
      immediate: true,
    },
  },
}
</script>

<style></style>
